import { Link } from 'react-router-dom';
import { navLinks, siteConfig } from '@/mocks/site';

export default function Footer() {
  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="mx-auto max-w-6xl px-4 py-14 md:px-6">
        <div className="grid gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-store-2-line text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-display text-xl text-foreground-950">{siteConfig.name}</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              关于《洞洞杂货铺》漫画世界观、故事背景与“洞洞”含义的科普站。读懂每一个空缺，也读懂光照进来的地方。
            </p>
            <div className="mt-5 flex items-center gap-3 text-foreground-500">
              <a href="#" aria-label="微博" className="flex h-9 w-9 items-center justify-center rounded-full bg-background-200 transition-colors hover:bg-primary-100 hover:text-primary-700">
                <i className="ri-weibo-line text-lg" aria-hidden="true"></i>
              </a>
              <a href="#" aria-label="社交平台" className="flex h-9 w-9 items-center justify-center rounded-full bg-background-200 transition-colors hover:bg-primary-100 hover:text-primary-700">
                <i className="ri-linkedin-line text-lg" aria-hidden="true"></i>
              </a>
              <a href={`mailto:${siteConfig.email}`} aria-label="邮箱" className="flex h-9 w-9 items-center justify-center rounded-full bg-background-200 transition-colors hover:bg-primary-100 hover:text-primary-700">
                <i className="ri-mail-line text-lg" aria-hidden="true"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold tracking-wide text-foreground-950">站点导航</h4>
            <ul className="mt-4 space-y-3">
              {navLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-sm text-foreground-600 transition-colors hover:text-primary-700">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold tracking-wide text-foreground-950">热门话题</h4>
            <ul className="mt-4 space-y-3 text-sm text-foreground-600">
              <li><Link to="/lore" className="transition-colors hover:text-primary-700">洞洞杂货铺世界观</Link></li>
              <li><Link to="/lore" className="transition-colors hover:text-primary-700">洞洞含义解读</Link></li>
              <li><Link to="/lore" className="transition-colors hover:text-primary-700">店主来历之谜</Link></li>
              <li><Link to="/faq" className="transition-colors hover:text-primary-700">新手入坑问答</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">© {new Date().getFullYear()} {siteConfig.name} · 内容站</p>
          <p className="text-xs text-foreground-500">读懂每一个空缺，也读懂光照进来的地方</p>
        </div>
      </div>
    </footer>
  );
}